import ArrowIcon from 'src/pages/dashboard/icons/foundry-health/right-arrow/index.vue'
import TickIcon from 'src/pages/dashboard/icons/foundry-health/tick-icon/index.vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import misc from 'src/utils/helper/misc'
import commonPopup from 'components/general/common-popup/index.vue'

import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_TYPES } from '../../../../../../modules/adobe-cja/constants'

export default {
  name: 'sidebarContentOverlay',
  components: {
    ArrowIcon,
    TickIcon,
    commonPopup
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter()
    const root = document.getElementById('app');
    const showPermissionNeededPopup = ref(false);
    const items = computed(() => store.getters['healthReport/getHealthReportChallenge']);
    const completedChallenge = computed(() => items.value.filter(item=>item.taskStatus == 'completed').length)
    const changeRoute = (item) => {      
      if (item.taskStatus == 'completed') {
        return
      }
      if (!checkPermission(item.taskRoute)) {
        showPermissionNeededPopup.value = true;
        return;
      }
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.FOUNDRY_HEALTH,
          linkSection: LINK_SECTION.DASHBOARD,
          linkName: item.taskRoute,
          linkType: LINK_TYPES.LINK_TEXT
        }
      })
      router.push({
        name: item.taskRoute,
        params: {
          id: store.getters['profile/sessionFoundryId'],
        }
      })
      root.style.overflow = 'unset'; 
    }

    const checkPermission = (permission) => {
      return misc.isFoundryHaveModulePermission(store.getters['profile/sessionFoundryId'], permission)
    }

    const closePermissionNeededPopup = () => {
      showPermissionNeededPopup.value = false;
    }

    return {
      items,
      completedChallenge,
      changeRoute,
      closePermissionNeededPopup,
      showPermissionNeededPopup
    };
  },
};